import Pusher from 'pusher-js';
import eventBus from '@/config/EventBus';
import CONST from '@/utils/Constants'
import oToast from '@/objects/o-toast/o-toast.vue'
import oButton from "@/objects/o-button/o-button.vue"
import oModal from "@/objects/o-modal/o-modal.vue"

export default {
    name: "LayoutTablet",
    components: {
       "o-toast": oToast,
       "o-button": oButton,
       "o-modal": oModal
    },
    data() {
      return {
        pusher: null,
        channel: null,
        idle: false,
        timeToIdle: 10,
        interval: null
      };
    },
    methods: {
      initializePusher() {
        if(!this.$store.state.pusherTabletInitiated) {
          const _this = this;

          if(!this.pusher) {
            this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
              cluster: 'eu'
            });

            if(process.env.VUE_APP_ENV != CONST.VALUE.ENV.PRODUCTION) {
              Pusher.logToConsole = true;
            }

            this.channel = this.pusher.subscribe(CONST.VALUE.PUSHER.CHANNEL);

            this.channel.bind(CONST.EVENT.QUEUE.UPDATED, function(data) {
              _this.$store.commit('drawings_count', data.message);
            });
          }
          this.$store.commit('pusherTabletInitiated', true);
        }
      },
      stop() {
        this.idle = false;
        clearInterval(this.interval);

        if(this.pusher) {
          this.pusher.unsubscribe(CONST.VALUE.PUSHER.CHANNEL); // unsubscribe from channel, so number of concurrent pusher connections stays low
        }

        window.location.href = '/'; // reload app, so everything is re-initiated
      },
      proceed() {
        this.idle = false;
        clearInterval(this.interval);
      }
    },
    mounted() {
      const $this = this;

      this.initializePusher();

      eventBus.$on(CONST.EVENT.DRAWING.SENT, function () {
        $this.stop();
      });
      eventBus.$on(CONST.EVENT.DRAWING.STOPPED, function () {
        $this.stop();
      });
    },
    onIdle() {
      const _this = this;
      this.timeToIdle = 10;

      if(this.$route.name != 'start') {
        this.idle = true;

        this.interval = setInterval(function(){
          _this.timeToIdle--;

          if(_this.timeToIdle == -1) {
            clearInterval(this.interval);

            _this.stop();
          }
        }, 1000);
      }
    }
};
